// extracted by mini-css-extract-plugin
export default {"ingameLayout":"blackjack_ingameLayout__SPbcu","game":"blackjack_game__kIizL","game__table":"blackjack_game__table__f92fP","moreGames":"blackjack_moreGames__6Gg-B"};